import { AnimatePresence, motion } from 'motion/react';
import { ChangeEvent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Input } from 'ui/components/Input';
import { cn } from 'utils/cn';
import { useDebounce } from '../../../hooks/debounce.ts';
import { setTextSearch } from '../../../store/filtersSlice.ts';

interface SearchBarProps {
  searchOpen: boolean;
}

export const SearchBar = ({ searchOpen }: SearchBarProps) => {
  const dispatch = useDispatch()
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    dispatch(setTextSearch(e.target.value))
  }
  const debouncedChange = useDebounce(handleChange, 300)

  useEffect(() => {
    if (!searchOpen) {
      dispatch(setTextSearch(undefined))
    }
  }, [searchOpen, dispatch]);

  return (
    <>
      <AnimatePresence>
        {searchOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0, transition: { duration: 0.1 } }}
            transition={{ duration: 0.2, type: 'spring', stiffness: 500, damping: 18, mass: 0.9 }}
          >
            <Input placeholder="Search" className={cn()} onChange={debouncedChange} />
          </motion.div>
        )}
      </AnimatePresence>
    </>

  );
};
